exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".blog{width:1200px;max-width:90vw;margin:3rem auto}.blog body h1,.blog body p{text-align:center}", "", {"version":3,"sources":["/var/home/ned/code/nedmahon/neddoesdev/src/views/Blog.vue"],"names":[],"mappings":"AACA,MAAM,aAAa,eAAe,gBAAgB,CACjD,AACD,2BAA2B,iBAAiB,CAC3C","file":"Blog.vue","sourcesContent":["\n.blog{width:1200px;max-width:90vw;margin:3rem auto\n}\n.blog body h1,.blog body p{text-align:center\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18601d5a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Blog.vue
// module id = 47
// module chunks = 0